<p-progressBar mode="{{ mode$ | async }}"></p-progressBar>
